import useAdminData from './useAdminData';
import { fetchAlerts } from '../../services/adminStatsService';

export default function AdminAlerts() {
  const { data, loading, error } = useAdminData(fetchAlerts);

  if (loading) return <div className="text-gray-500">Loading…</div>;
  if (error) return <div className="text-red-600">{error}</div>;
  if (!data) return null;

  const items = [
    { label: 'Conversations stuck in "new" > 24h', value: data.newOver24h, severity: 'high' },
    { label: 'Agent required > 30 min unassigned', value: data.agentRequiredOver30min, severity: 'high' },
    { label: 'Stale conversations (no activity > 48h)', value: data.staleConversations, severity: 'med' },
    { label: 'Failed messages last 24h', value: data.failedMessagesLast24h, severity: 'med' },
    { label: 'Inactive agents (7d no audit action)', value: data.inactiveAgents7d, severity: 'low' },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
      {items.map((item) => (
        <div
          key={item.label}
          className={`rounded-lg border p-4 ${
            item.value > 0
              ? item.severity === 'high'
                ? 'bg-red-50 border-red-200'
                : item.severity === 'med'
                  ? 'bg-amber-50 border-amber-200'
                  : 'bg-yellow-50 border-yellow-200'
              : 'bg-white border-gray-200'
          }`}
        >
          <div className="text-xs text-gray-600 mb-2">{item.label}</div>
          <div className="text-3xl font-semibold text-gray-900">{item.value ?? 0}</div>
        </div>
      ))}
    </div>
  );
}
